import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ypje",
  "use": "icon-ypje-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-ypje\"><path d=\"M381.63 256.98h247.267c76.522 0 134.89-165.727 134.89-165.727 0-49.635-4.974-87.186-89.951-89.82-84.934-2.676-105.282 59.32-166.327 59.32-62.566 0-93.857-48.743-170.847-59.32C259.686-9.2 246.74 41.619 246.74 91.254c0 0 58.353 165.727 134.89 165.727z m260.77 51.23H381.63c-288.768 0-359.687 566.608-359.687 566.608 0 74.43 60.387 149.182 134.89 149.182h710.349c74.488 0 134.875-74.752 134.875-149.182 0 0-70.934-566.609-359.658-566.609z m29.593 435.463a31.495 31.495 0 1 1 0 62.961H544.139v82.593a31.495 31.495 0 0 1-62.976 0v-82.593H352.475a31.495 31.495 0 1 1 0-62.961h128.688v-39.936H352.475a31.48 31.48 0 1 1 0-62.976h86.997l-89.06-158.077a31.51 31.51 0 0 1 54.536-31.51L512.19 640.761h5.427l107.228-189.587a31.48 31.48 0 0 1 42.993-11.483 31.451 31.451 0 0 1 11.557 42.993L590.32 640.761h81.672a31.466 31.466 0 1 1 0 62.976H544.139v39.936h127.854z\" p-id=\"4205\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ypje.svg
// module id = UlO/
// module chunks = 42